import { RouteObject } from "react-router-dom";
import { ProductGroup } from "./list";

export const ProductGroupRouter: RouteObject = {
  path: "/product-group",
  handle: { crumb: () => "Cadastros / Produtos / Grupo de Produtos" },
  children: [
    {
      index: true,
      element: <ProductGroup />,
    },
  ],
  errorElement: <h1>Route not found!</h1>,
};
